export var getAccessToken = function () {
    return (sessionStorage.getItem("user-token") ||
        localStorage.getItem("user-token") ||
        null);
};
export var deleteAccessToken = function () {
    sessionStorage.removeItem("user-token");
    localStorage.removeItem("user-token");
};



// WEBPACK FOOTER //
// ./src/shared/tokenUtils.js